var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible1,
            "close-on-click-modal": false,
            title: "爆品推荐",
            width: "900px",
            "custom-class": "dialog_box",
          },
          on: { close: _vm.onClose },
        },
        [
          _c(
            "div",
            { staticClass: "from_box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品数据来源:", prop: "sourceCode" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "80%" },
                          attrs: {
                            placeholder: "请选择模块",
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.ruleForm.sourceCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "sourceCode", $$v)
                            },
                            expression: "ruleForm.sourceCode",
                          },
                        },
                        _vm._l(_vm.options, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.activityName, value: item.id },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "font-size": "12px" } }, [
                        _vm._v("如果没有想要的商品列表，可前往【活动管理-"),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#66b1ff",
                              cursor: "pointer",
                            },
                            on: { click: _vm.openGoodsList },
                          },
                          [_vm._v("商品列表活动")]
                        ),
                        _vm._v("】内自己创建，然后在此处选中保存即可"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }